<script setup lang="ts">
/**
 * Boolean flag cell: a boxed check mark when `value` is true, a muted dash
 * otherwise. Center-aligned. Used for the "unlimited" column of the
 * subscription types table.
 */
defineProps<{
  value: boolean
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()
</script>

<template>
  <td class="check-flag-cell font-tufte">
    <span v-if="value" class="check-flag-cell__yes" aria-label="✓">✓</span>
    <span v-else class="check-flag-cell__no" aria-label="—">—</span>
  </td>
</template>

<style scoped>
.check-flag-cell {
  text-align: center;
}

.check-flag-cell__yes {
  display: inline-block;
  width: 1.45rem;
  height: 1.45rem;
  line-height: 1.35rem;
  border: 1px solid var(--color-gender-men);
  border-radius: 3px;
  color: var(--color-gender-men);
  font-size: 0.85rem;
}

.check-flag-cell__no {
  color: var(--color-tufte-muted);
  opacity: 0.6;
}
</style>
